import { render, staticRenderFns } from "./TransferFee.vue?vue&type=template&id=622e676c&"
import script from "./TransferFee.vue?vue&type=script&lang=js&"
export * from "./TransferFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports